import * as z from 'zod'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { FAILURE_STEP_NAME } from '@flows/insurance/constants'

const contents_permanent_residence = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('permanent_residence_in_germany')]: z.boolean(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contentsNxt:steps.contents_permanent_residence.title',
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('permanent_residence_in_germany'),
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('permanent_residence_in_germany'),
      valueToStepName: {
        true: 'contents_insurance_owned',
        false: FAILURE_STEP_NAME,
      },
    },
  }) as const satisfies AnyStepConfiguration

export default contents_permanent_residence
